import { styledByTheme } from "../../../../../../../themes/architecture/styled-by-theme";
import {LiveCasinoGridItemJackpotDefaultBox} from "./live-casino-grid-item-jackpot.default.box";
import {LiveCasinoGridItemJackpotCasino777Box} from "./live-casino-grid-item-jackpot.casino777.box";

export const LiveCasinoGridItemJackpotBox = styledByTheme(LiveCasinoGridItemJackpotDefaultBox)
    .forCasino777(LiveCasinoGridItemJackpotCasino777Box)
    .apply();
